// extracted by mini-css-extract-plugin
module.exports = {"cell":"product-cell-module--cell--1q-7J","unavailable":"product-cell-module--unavailable--3TWIu"};